import { Component, forwardRef, OnDestroy, OnInit } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { Subject, takeWhile } from 'rxjs';
import { EaSimulationScpiFormBuilder } from './ea-simulation-scpi-form.builder';

@Component({
    selector: 'ea-simulation-scpi-form',
    templateUrl: './ea-simulation-scpi-form.component.html',
    styleUrls: ['./ea-simulation-scpi-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaSimulationScpiFormComponent),
        },
    ],
    standalone: false
})
export class EaSimulationScpiFormComponent
  extends EaSimulationScpiFormBuilder
  implements OnInit, OnDestroy
{
  doneSubject: Subject<void> = new Subject<void>();
  alive = true;
  errorLoanDuration: ValidationErrors = null;
  errorProjectDuration: ValidationErrors = null;

  constructor(protected formConstructor: PrFormConstructor) {
    super(formConstructor);
  }

  ngOnInit() {
    this.form
      .get('ownership')
      .valueChanges.pipe(takeWhile(() => this.alive))
      .subscribe(ownership =>
        ownership == 'BARE_OWNERSHIP'
          ? this.form.get('cashOrCredit').setValue('CASH')
          : null,
      );

    this.form
      .get('cashOrCredit')
      .valueChanges.pipe(takeWhile(() => this.alive))
      .subscribe(cashOrCredit => {
        if (cashOrCredit == 'CREDIT' && this.entity.loanDuration)
          this.form.get('loanDuration').setValue(this.entity.loanDuration);
        else if (
          cashOrCredit == 'CREDIT' &&
          !this.form.get('loanDuration').value
        )
          this.form.get('loanDuration').setValue(240);
        else this.form.get('loanDuration').setValue(null);
      });

    this.form
      .get('dismembermentDuration')
      .valueChanges.pipe(takeWhile(() => this.alive))
      .subscribe(dismembermentDuration => {
        if (this.form.get('ownership').value == 'BARE_OWNERSHIP') {
          //this.form.get("dismembermentDuration").setValue(10);
          this.form.get('projectDuration').setValue(15);
        }
      });
    this.watchProjectDurationAndLoanDuration();
  }

  watchProjectDurationAndLoanDuration() {
    this.form
      .get('loanDuration')
      .valueChanges.pipe(takeWhile(() => this.alive))
      .subscribe(loanDuration => {
        if (
          (this.form.get('projectDuration')?.value ||
            this.form.get('projectDuration')?.value == 0) &&
          loanDuration
        ) {
          if (this.form.get('projectDuration')?.value * 12 > loanDuration) {
            this.form.get('loanDuration').setErrors({
              incorrect: true,

              message: 'la durée du crédit doit excéder la durée du projet',
            });
          } else {
            this.form.get('loanDuration').setErrors(null);
          }
          this.errorLoanDuration = this.form.get('loanDuration').errors;
        }
      });
    this.form
      .get('projectDuration')
      .valueChanges.pipe(takeWhile(() => this.alive))
      .subscribe(projectDuration => {
        if (
          (this.form.get('loanDuration')?.value ||
            this.form.get('loanDuration')?.value == 0) &&
          projectDuration
        ) {
          if (projectDuration * 12 > this.form.get('loanDuration')?.value) {
            this.form.get('projectDuration').setErrors({
              incorrect: true,

              message:
                'la durée du projet ne doit pas excéder la durée du crédit',
            });
          } else {
            this.form.get('projectDuration').setErrors(null);
          }
          this.errorProjectDuration = this.form.get('projectDuration').errors;
        }
      });
  }

  onProjectDurationChange(event) {
    if (
      this.form.get('loanDuration').value &&
      this.form.get('projectDuration').value >
        this.form.get('loanDuration').value / 12
    ) {
      this.form
        .get('projectDuration')
        .setValue(Math.floor(this.form.get('loanDuration').value / 12));
    }
  }

  get inCash() {
    return this.form.get('cashOrCredit').value == 'CASH';
  }

  onSubmit() {
    this.derrors = true;

    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }
    if (this.errorLoanDuration || this.errorProjectDuration) return;

    this.prFormService.loading();
    this.prFormService.loaded();

    const formDto = this.extract();
    this.doneSubject.next(formDto);
    if (this.callback) this.callback(formDto);
  }

  ngOnDestroy(): void {
    this.alive = false;
  }
}
